import { FC } from 'react';
import { useSearchParams } from 'react-router-dom';
import { SignUp } from 'auth/index';
import { OnboardingTemplate } from 'src/layout/OnboardingTemplate';
import { onboardingClerkAppearance } from 'src/layout/OnboardingTemplate/clerkAppearance';
import {
  homePath, newUserPath, signInPath, withBasePath,
} from 'src/routes/constants';
import { urlPathWithSearchParams } from 'src/util';
import { signupAttributionProperties } from 'src/utils/signupAttribution';

export const SignUpPage: FC = () => {
  const [searchParams] = useSearchParams();
  const searchParamString = searchParams.toString();

  return (
    <OnboardingTemplate>
      <SignUp
        appearance={onboardingClerkAppearance}
        // Consented campaign touches ride along on the Clerk user so the CRM sync
        // (Clerk user.created webhook) can record them; empty without consent.
        unsafeMetadata={{ amp_attribution: signupAttributionProperties() }}
        signInUrl={withBasePath(urlPathWithSearchParams(signInPath, searchParamString))}
        forceRedirectUrl={withBasePath(urlPathWithSearchParams(newUserPath, searchParamString))}
        signInForceRedirectUrl={withBasePath(urlPathWithSearchParams(homePath, searchParamString))}
      />
    </OnboardingTemplate>
  );
};
